import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then(m => m.HomePageModule)
  },
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadChildren: () => import('./components/Login/login/login.module').then(m => m.LoginPageModule)
  },
  {
    path: 'admin',
    loadChildren: () => import('./admin/admin.module').then(m => m.AdminPageModule)
  },
  {
    path: 'createaccount',
    loadChildren: () => import('./components/Login/createaccount/createaccount.module').then(m => m.CreateaccountPageModule)
  },
  {
    path: 'logingoogle',
    loadChildren: () => import('./components/Login/logingoogle/logingoogle.module').then(m => m.LogingooglePageModule)
  },
  {
    path: 'registerconfirmed',
    loadChildren: () => import('./components/Login/registerconfirmed/registerconfirmed.module').then(m => m.RegisterconfirmedPageModule)
  },
  {
    path: 'menudatereservation',
    loadChildren: () => import('./menudatereservation/menudatereservation.module').then(m => m.MenudatereservationPageModule)
  },
  {
    path: 'menureservationpax',
    loadChildren: () => import('./menureservationpax/menureservationpax.module').then(m => m.MenureservationpaxPageModule)
  },
  {
    path: 'menureservationterms',
    loadChildren: () => import('./menureservationterms/menureservationterms.module').then(m => m.MenureservationtermsPageModule)
  },
  {
    path: 'previousreservations1',
    loadChildren: () => import('./previousreservations/previousreservations.module').then(m => m.PreviousreservationsPageModule)
  },
  {
    path: 'certscannerqr',
    loadChildren: () => import('./certscannerqr/certscannerqr.module').then(m => m.CertscannerqrPageModule)
  },
  {
    path: 'notifications',
    loadChildren: () => import('./notifications/notifications.module').then(m => m.NotificationsPageModule)
  },
  {
    path: 'ofertahoteles/:LocationID',
    loadChildren: () => import('./components/oferta/ofertahoteles/ofertahoteles.module').then(m => m.OfertahotelesPageModule)
  },
  {
    path: 'register',
    loadChildren: () => import('./components/Login/register/register.module').then(m => m.RegisterPageModule)
  },
  {
    path: 'menusearchreservation',
    loadChildren: () => import('./components/Reservation/menusearchreservation/menusearchreservation.module').then(
      m => m.MenusearchreservationPageModule)
  },
  {
    path: 'requestreservation',
    loadChildren: () => import('./components/Reservation/requestreservation/requestreservation.module').then(
      m => m.RequestreservationPageModule)
  },
  {
    path: 'seereservation',
    loadChildren: () => import('./components/Reservation/seereservation/seereservation.module').then(m => m.SeereservationPageModule)
  },
  {
    path: 'reservationdetails',
    loadChildren: () => import('./components/Reservation/reservationdetails/reservationdetails.module').then(
      m => m.ReservationdetailsPageModule)
  },
  {
    path: 'certificatelist',
    loadChildren: () => import('./components/Certificate/certificatelist/certificatelist.module').then(m => m.CertificatelistPageModule)
  },
  {
    path: 'menucertificados',
    loadChildren: () => import('./components/Certificate/menucertificados/menucertificados.module').then(m => m.MenucertificadosPageModule)
  },
  {
    path: 'reservationcreation',
    loadChildren: () => import('./components/Reservation/reservationcreation/reservationcreation.module').then(
      m => m.ReservationcreationPageModule)
  },
  {
    path: 'previousreservations',
    loadChildren: () => import('./components/Reservation/previousreservations/previousreservations.module').then(
      m => m.PreviousreservationsPageModule)
  },
  {
    path: 'reservation-payment',
    loadChildren: () => import('./components/Payments/reservation-payment/reservation-payment.module').then(m => m.ReservationPaymentPageModule)
  },
  {
    path: 'add-card',
    loadChildren: () => import('./components/Payments/add-card/add-card.module').then(m => m.AddCardPageModule)
  },
  {
    path: 'insert-cvv',
    loadChildren: () => import('./components/Payments/insert-cvv/insert-cvv.module').then(m => m.InsertCVVPageModule)
  },
  {
    path: 'reservationcreationbypromotor/:HotelID/:LocationID/:TLocacionId/:CertificateInventoryID/:CertificateTypeID',
    loadChildren: () => import('./components/Reservation/reservationcreationbypromotor/reservationcreationbypromotor.module').then(m => m.ReservationcreationbypromotorPageModule)
  },
  {
    path: 'confirmation-payment',
    loadChildren: () => import('./components/Payments/confirmation-payment/confirmation-payment.module').then(m => m.ConfirmationPaymentPageModule)
  },
  {
    path: 'monitor/:hotelID',
    loadChildren: () => import('./components/availability/monitor/monitor.module').then(m => m.MonitorPageModule)
  }
  ,
  {
    path: 'qrgenerator',
    loadChildren: () => import('./components/Certificate/qrgenerator/qrgenerator.module').then(m => m.QrgeneratorPageModule)
  },
  {
    path: 'promotion-list/:hotelID/:locationID/:tLocacionId',
    loadChildren: () => import('./components/promotion/promotion-list/promotion-list.module').then( m => m.PromotionListPageModule)
  },
  {
    path: 'promotion-details/:promotionID/:hotelID/:locationID/:tLocacionId',
    loadChildren: () => import('./components/promotion/promotion-details/promotion-details.module').then( m => m.PromotionDetailsPageModule)
  },
  {
    path: 'live-chat/:hotelID/:CertificateInventoryID/:topicID',
    loadChildren: () => import('./components/chat/live-chat/live-chat.module').then( m => m.LiveChatPageModule)
  },
  {
    path: 'list-recent-events/:LocationID',
    loadChildren: () => import('./components/Certificate/list-recent-events/list-recent-events.module').then( m => m.ListRecentEventsPageModule)
  },
  {
    path: 'get-invoice',
    loadChildren: () => import('./components/Invoice/get-invoice/get-invoice.module').then( m => m.GetInvoicePageModule)  
  },
  {
    path: 'request-refund',
    loadChildren: () => import('./components/Payments/request-refund/request-refund.module').then( m => m.RequestRefundPageModule)
  },
  {
    path: 'status-refund',
    loadChildren: () => import('./components/Payments/status-refund/status-refund.module').then( m => m.StatusRefundPageModule)
  },
  {
    path: 'terms-conditions',
    loadChildren: () => import('./components/Reservation/terms-conditions/terms-conditions.module').then( m => m.TermsConditionsPageModule)
  },
  {
    path: 'edit-client',
    loadChildren: () => import('./components/Client/edit-client/edit-client.module').then( m => m.EditClientPageModule)
  },
  {
    path: 'plan-information',
    loadChildren: () => import('./components/Reservation/plan-information/plan-information.module').then( m => m.PlanInformationPageModule)
  },
  {
    path: 'invoice-request-confirmation',
    loadChildren: () => import('./components/Invoice/invoice-request-confirmation/invoice-request-confirmation.module').then( m => m.InvoiceRequestConfirmationPageModule)
  },
  {
    path: 'card-presentation',
    loadChildren: () => import('./components/card/card-presentation/card-presentation.module').then( m => m.CardPresentationPageModule)
  },
  {
    path: 'confirmemail',
    loadChildren: () => import('./components/Login/confirmemail/confirmemail.module').then( m => m.ConfirmemailPageModule)
  },
  {
    path: 'recoverpassword',
    loadChildren: () => import('./components/Login/recoverpassword/recoverpassword.module').then( m => m.RecoverpasswordPageModule)
  },
  {
    path: 'changepassword',
    loadChildren: () => import('./components/Login/changepassword/changepassword.module').then( m => m.ChangepasswordPageModule)
  },
  {
    path: 'avisoprivacidad',
    loadChildren: () => import('./components/General/avisoprivacidad/avisoprivacidad.module').then( m => m.AvisoprivacidadPageModule)
  },
  {
    path: 'terminosycondiciones',
    loadChildren: () => import('./components/General/terminosycondiciones/terminosycondiciones.module').then( m => m.TerminosycondicionesPageModule)
  },
  {
    path: 'insert-offline/:certificateID/:hotelID/:AmountPaid',
    loadChildren: () => import('./components/Payments/insert-offline/insert-offline.module').then( m => m.InsertOfflinePageModule)
  },
  {
    path: 'addprospect/:ClientID',
    loadChildren: () => import('./components/Login/addprospect/addprospect.module').then( m => m.AddprospectPageModule)
  }

];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { 
      useHash: true,
 
				scrollPositionRestoration: "enabled",
				anchorScrolling: "enabled",
				enableTracing: false,
      preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {
  constructor() {
  }
}
